<template>
  <div :class="['col-span-1 flex flex-col', itemStyle]">
    <span class="text-[13px] secondary_color">{{ label }}</span>

    <SkeletonLoader v-if="isLoading" :page="loaderPages.INFO_ITEM" />
    <template v-else>
      <slot>
        <span v-if="value" class="text-sm">{{ value }}</span>
        <span v-else class="text-sm secondary_color">{{ placeholder }}</span>
      </slot>
    </template>
  </div>
</template>

<script setup>
import { loaderPages } from "@/src/constants/loaderConstants.js";
import SkeletonLoader from "@/src/components/SkeletonLoader.vue";

defineProps({
  label: { type: String, required: true },
  value: { type: String, required: true },
  placeholder: { type: String, default: "--" },
  itemStyle: { type: String, default: "gap-1" },
  isLoading: { type: Boolean, default: false },
});
</script>
